/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { FreelancerVerificationStatus } from './';
import {
    FreelancerVerificationStatusFromJSON,
    FreelancerVerificationStatusFromJSONTyped,
    FreelancerVerificationStatusToJSON,
} from './';

/**
 * 
 * @export
 * @interface FreelancerVerificationDetailsResource
 */
export interface FreelancerVerificationDetailsResource {
    /**
     * Freelancer's legal form display name (e.g. Soletrader, EI)
     * @type {string}
     * @memberof FreelancerVerificationDetailsResource
     */
    legalForm?: string;
    /**
     * ISO 3166-1 alpha-2 country code of the freelancer's company
     * @type {string}
     * @memberof FreelancerVerificationDetailsResource
     */
    companyCountry?: string;
    /**
     * 
     * @type {FreelancerVerificationStatus}
     * @memberof FreelancerVerificationDetailsResource
     */
    identityStatus: FreelancerVerificationStatus;
    /**
     * 
     * @type {FreelancerVerificationStatus}
     * @memberof FreelancerVerificationDetailsResource
     */
    businessStatus: FreelancerVerificationStatus;
    /**
     * 
     * @type {FreelancerVerificationStatus}
     * @memberof FreelancerVerificationDetailsResource
     */
    regulatoryStatus: FreelancerVerificationStatus;
    /**
     * False when no regulatory documents are required for this freelancer's country.
     * @type {boolean}
     * @memberof FreelancerVerificationDetailsResource
     */
    isRegulatoryApplicable: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FreelancerVerificationDetailsResource
     */
    businessDownloadEnabled: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FreelancerVerificationDetailsResource
     */
    regulatoryDownloadEnabled: boolean;
}

/**
 * Check if a given object implements the FreelancerVerificationDetailsResource interface.
 */
export function instanceOfFreelancerVerificationDetailsResource(value: object): value is FreelancerVerificationDetailsResource {
    if (!('identityStatus' in value) || value['identityStatus'] === undefined) return false;
    if (!('businessStatus' in value) || value['businessStatus'] === undefined) return false;
    if (!('regulatoryStatus' in value) || value['regulatoryStatus'] === undefined) return false;
    if (!('isRegulatoryApplicable' in value) || value['isRegulatoryApplicable'] === undefined) return false;
    if (!('businessDownloadEnabled' in value) || value['businessDownloadEnabled'] === undefined) return false;
    if (!('regulatoryDownloadEnabled' in value) || value['regulatoryDownloadEnabled'] === undefined) return false;
    return true;
}

export function FreelancerVerificationDetailsResourceFromJSON(json: any): FreelancerVerificationDetailsResource {
    return FreelancerVerificationDetailsResourceFromJSONTyped(json, false);
}

export function FreelancerVerificationDetailsResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): FreelancerVerificationDetailsResource {
    if (json == null) {
        return json;
    }
    return {
        
        'legalForm': json['legalForm'] == null ? undefined : json['legalForm'],
        'companyCountry': json['companyCountry'] == null ? undefined : json['companyCountry'],
        'identityStatus': FreelancerVerificationStatusFromJSON(json['identityStatus']),
        'businessStatus': FreelancerVerificationStatusFromJSON(json['businessStatus']),
        'regulatoryStatus': FreelancerVerificationStatusFromJSON(json['regulatoryStatus']),
        'isRegulatoryApplicable': json['isRegulatoryApplicable'],
        'businessDownloadEnabled': json['businessDownloadEnabled'],
        'regulatoryDownloadEnabled': json['regulatoryDownloadEnabled'],
    };
}

export function FreelancerVerificationDetailsResourceToJSON(value?: FreelancerVerificationDetailsResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'legalForm': value['legalForm'],
        'companyCountry': value['companyCountry'],
        'identityStatus': FreelancerVerificationStatusToJSON(value['identityStatus']),
        'businessStatus': FreelancerVerificationStatusToJSON(value['businessStatus']),
        'regulatoryStatus': FreelancerVerificationStatusToJSON(value['regulatoryStatus']),
        'isRegulatoryApplicable': value['isRegulatoryApplicable'],
        'businessDownloadEnabled': value['businessDownloadEnabled'],
        'regulatoryDownloadEnabled': value['regulatoryDownloadEnabled'],
    };
}

